import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Method } from 'axios'
import { tokenResponseDto } from '../types/TokenResponseDto.tsx'
import callApi from '../services/callApi.tsx'

// Beispielstruktur für die Antwort
export interface TokenSliceResponse {
  data: tokenResponseDto
}

// Beispielstruktur für Fehler
interface Error {
  message: string
}

// Typdefinition für den Anfangszustand
interface State {
  fehler: string | null
  ladeStatus: 'idle' | 'loading' | 'erfolgreich' | 'fehlgeschlagen'
}

interface FetchApiDataOptions {
  url: string
  token?: string
  method: Method // 'GET', 'POST', 'PUT', 'DELETE', etc.
  bodyData?: object
}

// Anfangszustand definieren
const initialState: State = {
  fehler: null,
  ladeStatus: 'idle',
}

// Erstellen einer asynchronen Thunk Funktion
export const getToken = createAsyncThunk<TokenSliceResponse, FetchApiDataOptions, { rejectValue: Error }>('getToken', async ({ url, method, bodyData }, { rejectWithValue }) => {
  try {
    const response = await callApi({
      url,
      method,
      bodyData,
    })
    if (response.status === 200) {
      return { data: response.data }
    } else {
      return rejectWithValue({ message: 'Nicht erfolgreicher Statuscode' })
    }
  } catch (error: unknown) {
    if (error instanceof Error && error.message) {
      return rejectWithValue({ message: error.message })
    } else {
      return rejectWithValue({ message: 'Unbekannter Fehler' })
    }
  }
})

// Erstellen eines Slices
const tokenSlice = createSlice({
  name: 'tokenSlice',
  initialState,
  reducers: {
    // Weitere Reducer für andere Aktionen definieren
  },
  extraReducers: (builder) => {
    builder

      //Create Or Update Events
      .addCase(getToken.pending, (state) => {
        state.ladeStatus = 'loading'
      })
      .addCase(getToken.fulfilled, (state) => {
        state.ladeStatus = 'erfolgreich'
        state.fehler = null
      })
      .addCase(getToken.rejected, (state, action: PayloadAction<Error | undefined, string, { arg: FetchApiDataOptions; requestId: string }, SerializedError>) => {
        state.ladeStatus = 'fehlgeschlagen'
        if (action.payload?.message) {
          state.fehler = action.payload?.message || action.error?.message || 'Unbekannter Fehler'
        }
      })
  },
})

// Exportieren der Reducer und Aktionen
export const { actions } = tokenSlice

export default tokenSlice.reducer
